(function () {
    'use strict';
    $(document).ready(function () {
        if ($('.homepage').length) {

        }
    });
}(jQuery));
